import { Outlet } from 'react-router-dom';
import Forbidden from '@/pages/Forbidden';
import { useAuth } from './useAuth';

interface Props {
  anyOf: string[];
}

/** Route-level guard. Renders the Forbidden page if the user lacks all listed permissions. */
export default function PermissionRoute({ anyOf }: Props) {
  const { hasAnyPermission } = useAuth();
  return hasAnyPermission(anyOf) ? <Outlet /> : <Forbidden />;
}
